export default __webpack_public_path__ + "static/media/sanmat15.d2aa5d3c.jpg";